import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseRule from "../BaseRule.vue";
import { computed } from "vue";
export default {
  __name: 'TaxRecord',
  props: ["index", "data"],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const data = computed(() => props.data);
    const word = {
      first: "近",
      second: "月,有缴税记录",
      name: "TaxRecord",
      label: "近期纳税时长"
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, null, 8, ["index", "data"]);
    };
  }
};